// extracted by mini-css-extract-plugin
module.exports = {"limited":"limitedWidth--limited--17PGx","button":"limitedWidth--button--3lxiC","header":"limitedWidth--header--28-Cb","list":"limitedWidth--list--2IGeF"};